import { render } from "./ConversionMonnaiePage.vue?vue&type=template&id=c685effa&ts=true"
import script from "./ConversionMonnaiePage.vue?vue&type=script&lang=ts"
export * from "./ConversionMonnaiePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__